/**
 *
 * 项目全局配置文件
 */
// const IS_DEV = process.env.NODE_ENV === 'development';

// 主域名: www.baibu.la => baibu.la; www.ibaibu.com => ibaibu.com
export function getEnv(defaultEnv = 'dev') {
  const defaultMainDomain = 'eagleeye-api.ibaibu.com';

  // eagleeye.ibaibu.com
  const { hostname } = window.location;
  const isLocal = /(^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$)|(^localhost$)/.test(hostname);

  const domains = hostname.split('.');
  const [levelDomain] = domains;

  let prefix;
  const prefixList = levelDomain.split('-');

  if (isLocal) {
    prefix = defaultEnv;
  } else if (prefixList.length === 1) {
    prefix = 'production';
  } else {
    [prefix] = prefixList;
  }

  return {
    isLocal,
    mainDomain: defaultMainDomain,
    levelDomain,
    prefix,
  };
}

// 获取 api 前置路径
export const API_BASE = (function fn() {
  const { prefix } = getEnv();
  const APIS = {
    production: {
      //  base: `https://${mainDomain}`,
      base: 'https://paas-api.ibaibu.com',
      // paas: 'https://paas-api.ibaibu.com',
      monitor: 'https://fe-monitor.ibaibu.com',
      prefix,
    },
    others: {
      // base: `https://${prefix}-${mainDomain}`,
      base: `https://${prefix}-paas-api.ibaibu.com`,
      // paas: `https://${prefix}-paas-api.ibaibu.com`,
      // base: 'http://10.25.1.70:8080',
      // paas: 'http://10.25.1.70:8080',
      open:
        ['dev'].includes(prefix)
          ? 'https://uat-openapi.ibaibu.com'
          : 'https://openapi.ibaibu.com',
      monitor: `https://${prefix}-fe-monitor.ibaibu.com`,
      prefix,
    },
  };

  return APIS[prefix] || APIS.others;
}());
